import { useQuery } from "@tanstack/react-query";
import { useEffect, useState, useCallback } from "react";

import { getEventsByOrderId, getOrders } from "./api";
import { ordersStore } from "./store";
import { OrderGetDto } from "./dto";

function useFetchOrders(params) {
  const { setOrders } = ordersStore();
  const [orders, _setOrders] = useState([]);
  const getEmail = JSON.parse(localStorage.getItem("dbhuseread"));
  const { username } = getEmail;

  const { data, isError, error, refetch, status, isFetching } = useQuery({
    queryKey: ["orders"],
    queryFn: () => getOrders({ ...params, Usuario: username }),
    enabled: false,
  });

  useEffect(() => {
    if (data) {
      const mappedOrders = data.map((order) => new OrderGetDto(order));
      setOrders(mappedOrders);
      _setOrders(mappedOrders);
    }
  }, [data, setOrders]);

  return { data, isError, error, orders, refetch, status, isFetching };
}

function useFetchEventsByOrderId(orderId) {
  const { setEvents } = ordersStore();
  const [events, _setEvents] = useState([]);

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["events"],
    queryFn: () => getEventsByOrderId(orderId),
  });

  useEffect(() => {
    if (data) {
      setEvents(data);
      _setEvents(data);
    }
  }, [data, setEvents]);

  return { data, isLoading, isError, error, events };
}

function useFetchOrdersById(orderId) {
  return ordersStore(
    useCallback(
      (state) => state.orders.find((s) => s.id === orderId),
      [orderId]
    )
  );
}

function useFilteredOrders() {
  return ordersStore.getState().filteredOrders;
}

function useFilters() {
  return {
    selectedFilters: ordersStore.getState().selectedFilters,
    addFilter: (filter) => ordersStore.getState().addSelectedFilter(filter),
    removeFilter: (filter) =>
      ordersStore.getState().removeSelectedFilter(filter),
    resetFilters: () => ordersStore.getState().resetFilters(),
  };
}

function useFetchOrdersBy(filters) {
  return ordersStore.getState().filterOrders(filters);
}

export {
  useFetchOrders,
  useFetchOrdersById,
  useFilteredOrders,
  useFetchOrdersBy,
  useFetchEventsByOrderId,
  useFilters,
};
